import type { ReactNode } from "react";
import { cn } from "../../lib/utils.js";

export function CampaignReviewGroup({
  titleId,
  title,
  testId,
  children,
  footer,
  bodyClassName,
}: {
  titleId: string;
  title: string;
  testId?: string;
  children: ReactNode;
  footer?: ReactNode;
  bodyClassName?: string;
}): React.JSX.Element {
  return (
    <section
      className="grid min-w-0 gap-0 rounded-xl border border-line/60 bg-surface-muted/70"
      aria-labelledby={titleId}
      data-testid={testId}
    >
      <h3 id={titleId} className="m-0 px-4 py-2.5 text-[0.8125rem] font-semibold">
        {title}
      </h3>
      <div
        className={cn(
          "min-w-0 rounded-b-xl border-t border-line/60 bg-surface p-2.5 sm:p-3",
          bodyClassName,
        )}
      >
        {children}
        {footer}
      </div>
    </section>
  );
}
